<template>
  <div>
    <Panel
      class="intro-y"
      :title="title"
      :btn-name="(loanId || customerId) && !disabled ? $t('text.add') : null"
      :btn-name-second="seeAll ? $t('text.allNotesHistory') : null"
      @click="showModal"
      @clickSecondButton="$emit('clickAll')"
    >
      <LoadingWithText v-if="isLoading" />
      <div class="-m-5" v-else-if="list.length > 0">
        <div
          v-for="(note, index) in list"
          :key="index"
          :class="[
            'border-gray-200 dark:border-dark-5 px-5 py-4 relative',
            { 'border-t': index > 0 },
          ]"
        >
          <template v-if="loanId">
            <div class="flex items-center justify-between">
              <strong v-if="note.creator">{{ note.creator | fullName }}</strong>
              <strong v-if="note.reminderDate">{{ note.reminderDate }}</strong>
            </div>
            <div class="mt-2 text-gray-600">{{ note.description }}</div>
            <div class="mt-2 flex items-center justify-between">
              <span class="text-xs text-gray-600">
                {{ note.createdAt | momentDate('YYYY-MM-DD HH:mm:ss') }}
              </span>
            </div>
          </template>
          <template v-else>
            <div class="flex items-center justify-between">
              <CustomerDetailsPopover v-if="isOfficer" :user="getUser(note)" :another-key="index" />
              <strong v-else>{{ note.creator | fullName }}</strong>
              <strong v-if="note.reminderDate">{{ note.reminderDate }}</strong>
            </div>
            <div class="mt-2 text-gray-600">{{ note.description }}</div>
            <div class="mt-2 flex items-center justify-between">
              <LoanDetailsPopover
                v-if="note.loanId && note.loan"
                :loan="note.loan"
                :another-key="index"
              />
              <span class="text-xs text-gray-600">{{
                note.createdAt | momentDate('YYYY-MM-DD HH:mm:ss')
              }}</span>
            </div>
          </template>
        </div>
      </div>
      <NoItems v-else />
    </Panel>
    <NoteAddModal :modal-id="modalId" :loan-id="loanId" :customer-id="customerId" />
  </div>
</template>

<script>
import Panel from '@/components/ui/Panel';
import NoItems from '@/components/ui/NoItems';
import CustomerDetailsPopover from '@/components/customer/CustomerDetailsPopover';
import LoanDetailsPopover from '@/components/loan/LoanDetailsPopover';
import NoteAddModal from '@/components/note/NoteAddModal';

export default {
  props: {
    list: Array,
    isLoading: {
      type: Boolean,
      default: false,
    },
    title: String,
    loanId: {
      type: Number,
      default: null,
    },
    customerId: {
      type: Number,
      default: null,
    },
    isOfficer: {
      type: Boolean,
      default: false,
    },
    seeAll: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Panel,
    NoItems,
    CustomerDetailsPopover,
    LoanDetailsPopover,
    NoteAddModal,
  },

  data() {
    return {
      modalId: 'note-add-modal',
    };
  },

  methods: {
    getUser(note) {
      let result;
      if (note.loanId && note.loan?.user) {
        result = note.loan.user;
      }
      if (note.userId && note.user) {
        result = note.user;
      }
      return result;
    },
    showModal() {
      cash(`#${this.modalId}`).modal('show');
    },
  },
};
</script>
